import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../layouts/Breadcrumb";
import Clients from "../layouts/Clients";
import Content from "../sections/blogdetails/Content";

class Terms extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };
  render() {
    return (
      <Fragment>
        <MetaTags>
          <title>Terms | G9 Gems</title>
          <meta name="description" content="#" />
        </MetaTags>
        <Header />

        <div className="section sigma_post-single mt-5">
          <div className="container">
            <div className="row">
              <div className="section-title text-center">
                <h4>Terms & Conditions</h4>
                <ol>
                  <li>
                    This report describes the result & grade of specimen on the
                    said date and time. If the lapecimen is subjected to any
                    alteration, this report will not be valid.
                  </li>
                  <li>
                    For security each report carries photograph of the specimen
                    being tested. Also look for the watermark of G9 gems. Each
                    report contains a QR code which is unique to the issued
                    report and used for its online verification at laboratory's
                    official website https://gemsanine.com/verify
                  </li>
                  <li>
                    The report is provided on the request of the customers for
                    the specimen. Neither the client nor the purchaser of the
                    specimen, shall regard this report as an appraisal /
                    guarantee/ warranty and for any other purpose can hold GIL
                    liable.
                  </li>
                  <li>
                    The image printed on the report may differ from its physical
                    appearences and measurements. Tests which are not applicable
                    or useful in identification are not performed.
                  </li>
                  <li>
                    In the event of any claim by the client or any person for
                    the damage to the specimen, or damage resulting directly or
                    indirectly from the report, the liability of GIL shall be
                    limited to the amount it receives as fee, in connection with
                    the report.
                  </li>
                  <li>
                    GIL is on no account responsible for possible
                    dissimilarities and/or differences that could appear from
                    repeated examinations or as a result of other methods
                    applied or the possible inaccuracy due to the
                    technical/mechanical defects/errors of the
                    instruments/equipments used.
                  </li>
                  <li>
                    The results shall be governed by the Judicial systems and
                    all matters, disputes or references to the arbitration shall
                    be subject to the Nagpur jurisdiction.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  }
}

export default Terms;
